import * as types from '../../constants/actions';

const initialState = {
  status: 'idle',
  isErrored: false,
  providers: [],
};

const fetchProviders = (state = initialState, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        isErrored: false,
        status: 'loading',
      };
    case 'success':
      return {
        ...state,
        providers: action.providers,
        isErrored: false,
        status: 'success',
      };
    case 'error':
      return {
        ...state,
        isErrored: true,
        status: 'error',
      };
    default:
      return state;
  }
};

const ltiReducer = (state = initialState, action) => {
  if (!action) {
    return state;
  }

  switch (action.type) {
    case types.LTI_FETCH_PROVIDERS:
      return fetchProviders(state, action);
    default:
      return state;
  }
};

export default ltiReducer;
